import React from "react";
import './Button.css';
import { useNavigate } from "react-router-dom";

const UserManButton = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/usermanagement')
    };

    return (
        <button className="userMan-button" onClick={handleClick}>
            User Management
        </button>
    );
}
export default UserManButton;